"use client";

import styles from "./venus-enquiry-form.module.css";

function Padlock() {
  return (
    <>
      <rect x="0" y="4" width="9" height="7" rx="1.2" className={styles.lock} />
      <path d="M1.8 4 V2.6 a2.7 2.7 0 0 1 5.4 0 V4" className={styles.lockShackle} />
    </>
  );
}

/** One chassis, three bays: your bay sits between other MLX tenants, padlocked apart. */
export function SharedServerDiagram() {
  return (
    <svg className={styles.diagram} viewBox="0 0 240 150" aria-hidden="true">
      <text x="120" y="16" textAnchor="middle" className={styles.tinyText}>
        one MLX server
      </text>
      <rect x="20" y="26" width="200" height="102" rx="8" className={styles.line} />
      <line x1="86.6" y1="34" x2="86.6" y2="120" className={styles.divider} />
      <line x1="153.3" y1="34" x2="153.3" y2="120" className={styles.divider} />
      <g>
        <line x1="34" y1="54" x2="74" y2="54" className={styles.workload} />
        <line x1="34" y1="70" x2="66" y2="70" className={styles.workload} />
        <text x="33" y="112" className={styles.tinyText}>
          tenant
        </text>
        <text x="33" y="123" className={styles.tinyText}>
          workload
        </text>
      </g>
      <rect x="86.6" y="34" width="66.7" height="86" className={styles.youFill} />
      <text x="120" y="78" textAnchor="middle" className={styles.youText}>
        YOU
      </text>
      <text x="120" y="98" textAnchor="middle" className={styles.tinyText}>
        your model
      </text>
      <g>
        <line x1="166" y1="54" x2="206" y2="54" className={styles.workload} />
        <line x1="166" y1="70" x2="198" y2="70" className={styles.workload} />
        <text x="165" y="112" className={styles.tinyText}>
          tenant
        </text>
        <text x="165" y="123" className={styles.tinyText}>
          workload
        </text>
      </g>
      <g transform="translate(82.4 66)">
        <Padlock />
      </g>
      <g transform="translate(149.1 66)">
        <Padlock />
      </g>
      <text x="120" y="144" textAnchor="middle" className={styles.tinyText}>
        isolated bays · your data stays in yours
      </text>
    </svg>
  );
}

/** One chassis inside a dashed boundary of its own: nothing else runs on the machine. */
export function DedicatedServerDiagram() {
  return (
    <svg className={styles.diagram} viewBox="0 0 240 168" aria-hidden="true">
      <rect x="10" y="18" width="220" height="118" rx="10" className={styles.moat} />
      <text x="120" y="34" textAnchor="middle" className={styles.tinyText}>
        your boundary
      </text>
      <rect x="44" y="48" width="152" height="64" rx="8" className={styles.line} />
      <rect x="44" y="48" width="152" height="64" rx="8" className={styles.youFill} />
      <text x="120" y="74" textAnchor="middle" className={styles.youText}>
        YOU
      </text>
      <text x="120" y="94" textAnchor="middle" className={styles.tinyText}>
        the whole machine
      </text>
      <text x="120" y="160" textAnchor="middle" className={styles.tinyText}>
        no other workload on this hardware
      </text>
    </svg>
  );
}

/** EQ-fader mark: a stock chip runs one shape for everyone; a tuned chip is set to you. */
export function TuningChip({ tuned }: { tuned: boolean }) {
  const knobY = tuned ? [28, 50, 38] : [42, 42, 42];
  return (
    <svg className={styles.diagram} viewBox="0 0 240 96" aria-hidden="true" style={{ maxWidth: 200 }}>
      <rect x="30" y="6" width="180" height="64" rx="8" className={styles.line} />
      {[75, 120, 165].map((x, i) => (
        <g key={x}>
          <line x1={x} y1="16" x2={x} y2="60" className={styles.divider} />
          <circle
            cx={x}
            cy={knobY[i]}
            r="6"
            fill={tuned ? undefined : "none"}
            className={tuned ? styles.lock : styles.workload}
            strokeWidth={tuned ? undefined : 2.2}
          />
        </g>
      ))}
      <text x="120" y="88" textAnchor="middle" className={styles.tinyText}>
        {tuned ? "set to you" : "one shape, everyone"}
      </text>
    </svg>
  );
}
